import React, { useEffect, useState } from "react";
import {
  documentUpload,
  fetchCategories,
  GetAllTypeStudent,
} from "../../api/Documents";
import { closeModal, closeOffcanvas, SweetAlertShow } from "../master/Master";
import "./Form.css";
import { viewlist } from "../../api/BatchService";
import Select from "react-select";

const BaseForm = ({ defaultCategory, StudentId, batch_id }) => {
  const [Student_Id, setStudentId] = useState(StudentId || "");
  const [student, setStudent] = useState(null);

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const [category, setCategory] = useState([]);
  const [formEntries, setFormEntries] = useState([]);

  const [batch, setBatch] = useState();
  const [selectedBatch, setSelectedBatch] = useState("");

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddEntry = () => {
    setFormEntries([
      ...formEntries,
      { category_id: "", doc_type: "hard", remark: "", file: null },
    ]);
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...formEntries];
    updated[index][name] = value;
    setFormEntries(updated);
  };

  const handleFileChange = (index, e) => {
    const updated = [...formEntries];
    updated[index].file = e.target.files[0];
    setFormEntries(updated);
  };

  const handleDeleteEntry = (index) => {
    setFormEntries(formEntries.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!Student_Id) {
      SweetAlertShow("warning", "Required", "Please select student");
      return;
    }

    setIsLoading(true);

    const formData = new FormData();

    formEntries.forEach((entry) => {
      formData.append("type", defaultCategory);
      formData.append("student_id", Student_Id);

      if (defaultCategory === "student") {
        formData.append("batch_id", selectedBatch || Number(batch_id || ""));
      }

      formData.append("category_id[]", entry.category_id);
      formData.append("doc_type[]", entry.doc_type);
      formData.append("remark[]", entry.remark);

      if (entry.file) {
        formData.append("file[]", entry.file);
      }
    });

    try {
      const response = await documentUpload(formData);
      if (response?.data?.status) {
        setFormEntries([]);
        closeOffcanvas("documentOffcanvas");
        closeModal("editUser");
        SweetAlertShow("success", "Success", response.data.message);
      } else {
        SweetAlertShow("info", "Warning", response.data.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message || error.message
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await viewlist();
        if (response?.data?.status) {
          setBatch(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchBatches();
  }, []);

 const fetchStudent = async () => {
  let addUrl = `&type=${defaultCategory}`;

  if (defaultCategory === "student" && selectedBatch) {
    addUrl += `&batch_id=${selectedBatch}`;
  }

  if (search) addUrl += `&search=${search}`;

  try {
    const response = await GetAllTypeStudent(addUrl);
    if (response.data.status) {
      const formatted = response.data.data.map((st) => {
      
        const name =
          st.student_name ||
          st.name ||
          st.full_name ||
          "Unknown";

        let extra = "";

        if (defaultCategory === "student") {
          extra = st.registration_no
            ? ` (${st.registration_no})`
            : "";
        } else {
          extra = st.phone
            ? ` (${st.phone})`
            : st.email
            ? ` (${st.email})`
            : "";
        }

        return {
          value: st.id,
          label: `${name}${extra}`,
        };
      });

      setData(formatted);
    }
  } catch (error) {
    // SweetAlertShow(
    //   "error",
    //   "Error",
    //   error?.response?.data?.message || error.message
    // );
  }
};


  useEffect(() => {
    if (["student", "marketing", "enquiry"].includes(defaultCategory)) {
      fetchStudent();
    }
  }, [defaultCategory, selectedBatch, search]);

  useEffect(() => {
    const categoryFetch = async () => {
      try {
        const response = await fetchCategories(`&type=${defaultCategory}`);
        if (response.data.status) {
          setCategory(response.data.data);
        }
      } catch (error) {
        SweetAlertShow(
          "error",
          "Error",
          error?.response?.data?.message || error.message
        );
      }
    };

    if (defaultCategory) categoryFetch();
  }, [defaultCategory]);

  useEffect(() => {
    setStudent(null);
    setStudentId("");
    if (defaultCategory !== "student") {
      setSelectedBatch("");
    }
  }, [defaultCategory]);

  return (
    <>
      {/* Batch Select - ONLY STUDENT */}
      {defaultCategory === "student" && (
        <div className="col-md-12 form-floating form-floating-outline mb-2">
          <select
            className="form-select"
            value={selectedBatch}
            onChange={(e) => setSelectedBatch(e.target.value)}
          >
            <option value="">Select Batch</option>
            {batch?.batches?.map((b) => (
              <option key={b.id} value={b.id}>
                {b.title}
              </option>
            ))}
          </select>
          <label>Select Batch</label>
        </div>
      )}


      {/* Student Select - ALL THREE */}
      {["student", "marketing", "enquiry"].includes(defaultCategory) && (
        <div className="mb-3">
          <Select
            options={data}
            isSearchable
            value={student}
            onChange={(option) => {
              setStudent(option);
              setStudentId(option?.value || "");
            }}
            placeholder={
              defaultCategory === "student"
                ? "Select Student (Batch wise)"
                : "Search Student"
            }
          />
        </div>
      )}

      {/* FORM */}
      <form onSubmit={handleSubmit}>
        {formEntries.map((entry, index) => (
          <div key={index}>
            <div className="mb-3 form-floating">
              <select
                className="form-select"
                name="category_id"
                value={entry.category_id}
                onChange={(e) => handleInputChange(index, e)}
                required
              >
                <option value="">Select Category</option>
                {category.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.title}
                  </option>
                ))}
              </select>
              <label>Document Category</label>
            </div>

            {/* HARD / SOFT */}
            <div className="d-flex gap-2 mb-2">
              {["hard", "soft"].map((type) => (
                <label key={type} className="btn btn-outline-primary btn-sm">
                  <input
                    type="radio"
                    name={`doc_type_${index}`}
                    value={type}
                    checked={entry.doc_type === type}
                    onChange={() => {
                      const updated = [...formEntries];
                      updated[index].doc_type = type;
                      setFormEntries(updated);
                    }}
                  />{" "}
                  {type}
                </label>
              ))}
            </div>

            <div className="form-floating mb-3">
              <input
                className="form-control input-uppercase"
                name="remark"
                value={entry.remark}
                onChange={(e) => handleInputChange(index, e)}
                placeholder="Remark"
              />
              <label>Remark</label>
            </div>

            <input
              type="file"
              className="form-control mb-3"
              onChange={(e) => handleFileChange(index, e)}
            />

            <button
              type="button"
              className="btn btn-sm btn-danger mb-3"
              onClick={() => handleDeleteEntry(index)}
            >
              Delete
            </button>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-outline-primary mb-3"
          onClick={handleAddEntry}
        >
          +
        </button>

        <button className="btn btn-primary" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </>
  );
};

export default BaseForm;
